import React from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import HomepageCreator from "@/components/landing/HomepageCreator";
import ValueMarquee from "@/components/landing/ValueMarquee";
import Pillars from "@/components/landing/Pillars";
import UseCases from "@/components/landing/UseCases";
import AntiCreditTrap from "@/components/landing/AntiCreditTrap";
import ByokExplainer from "@/components/landing/ByokExplainer";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="bg-[#080808] text-[#F4F4F0] min-h-screen">
      <Nav />
      <main>
        <Hero />
        <HomepageCreator />
        <ValueMarquee />
        <Pillars />
        <UseCases />
        <AntiCreditTrap />
        <ByokExplainer />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
